function createChunk() {
  const items = [];
  const region = [Infinity, -Infinity];
  const indices = [Infinity, -Infinity];
  return {
    getRegion: () => region,
    hasOverlap: (item) => item.region.g0 < region[1],
    getIndices: () => indices,
    getItems: () => items,
    addItem: (item, i) => {
      items.push(item);
      indices[0] = Math.min(indices[0], i);
      indices[1] = Math.max(indices[1], i);
      region[0] = Math.min(region[0], item.region.g0);
      region[1] = Math.max(region[1], item.region.g1);
    },
  };
}

/*
  merges items with overlapping regions into chunks so that bisecting can be applied. 
  It works well for sparce arrays of regions
*/
function createOverlapChunks(sortedArrayOfRegionItems) {
  const arr = sortedArrayOfRegionItems;
  const chunks = [];

  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    const prevChunk = chunks[chunks.length - 1] || createChunk();

    if (prevChunk.hasOverlap(item)) {
      prevChunk.addItem(item, i);
    } else {
      const chunk = createChunk();
      chunks.push(chunk);
      chunk.addItem(item, i);
    }
  }

  return chunks.map((x) => ({
    region: x.getRegion(),
    indices: x.getIndices(),
    items: x.getItems(),
  }));
}

export default createOverlapChunks;
